import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Empty, Spin } from "antd";
import { DetailModel, DetailModelCustomer } from "../../components/Model/index-model";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import AppContext from "../../components/AppContext";
import { Table } from "antd";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import {
  getRandomuserParams,
  hasPermission,
  scrollToAntSpinContainer,
  showToast,
} from "../../utils";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";
import Apibank from "../../api/Apibank";
import { ColumnsVerifySlip } from "../../components/Columns/columns-verify-trans";
import { ContentVerifySlip } from "./content-verifyslip";
import { getRowClassName } from "../../helpers/getRowClassName";
import SearchTransactions from "./components/SearchTransactions";
import moment from "moment";
import { debounce } from "lodash";
import { getSearchCustomerData } from "../../utils/fetchData";
import { FooterVerifyslip } from "../../components/Footer";

// const { Search } = Input;

class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isSearching: false,
      expanded: false,
      showDetailCustomer: false,
      customerData: null,
      isData: null,
      isLoad: false,
      searchText: "",
      isMobile: window.innerWidth <= 768,
      showModelSearch: false,
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.handleIsSearching = this.handleIsSearching.bind(this);
    this.debouncedFetch = debounce(this.fetchData, 100);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.scrollTo(0, 0);
    this.setState({ isLoad: true, isSearching: false }, () => {
      this.debouncedFetch();
    });
    if (this.context.setFetchVerifyslipDataCallback) {
      this.context.setFetchVerifyslipDataCallback(this.handleReload);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    // ทำความสะอาด debounce เพื่อป้องกัน memory leaks
    this.debouncedFetch.cancel();
  }
  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  handleReload = () => {
    this.setState({ isLoad: true }, () => this.debouncedFetch());
  };

  setLoading = (_loading) => {
    this.setState({ isLoad: _loading });
  };
  fetchData = async () => {
    const { tableParams, isSearching } = this.state;
    const { handleCheckError, setCountVerifySlip, setReloading } = this.context;
    const { startDate, endDate, searchText, typeSearch, status } =
      tableParams.filters;

    const params = getRandomuserParams(tableParams);
    let searchData = {
      startDate,
      endDate,
      search: searchText,
      typeSearch,
      status,
      limit: params.limit,
      page: params.page,
    };
    let itemParam = {
      limit: params.limit,
      page: params.page,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    try {
      const res = await Apibank.getVerifyslipTransactions(
        !isSearching ? itemParam : searchData,
      );
      if (res.status === 200) {
        const fetchedData = Array.isArray(res.data.data) ? res.data.data : [];

        this.setState(
          (prevState) => ({
            dataTable: fetchedData,
            tableParams: {
              ...prevState.tableParams,
              pagination: {
                ...prevState.tableParams.pagination,
                total: res.data.count,
                current: tableParams.pagination.current,
                pageSize: tableParams.pagination.pageSize,
              },
            },
            isLoad: false,
          }),
          () => {
            setCountVerifySlip(res.data.count);
            setReloading(false);
          },
        );
      } else {
        showToast("error", res.data.message || "Failed to fetch data.");
        this.setState({ isLoad: false });
      }
    } catch (error) {
      handleCheckError(error);
      console.error("Error in fetchData:", error);
      this.setState({ isLoad: false });
    }
  };

  handleClose = () => {
    this.setState({
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      customerData: null,
      showDetailCustomer: false,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      (prevState) => ({
        isLoad: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...pagination,
            total: prevState.tableParams.pagination.total,
          },
          filters: { ...prevState.tableParams.filters, ...filters },
          sortField: Array.isArray(sorter) ? sorter[0]?.field : sorter.field,
          sortOrder: Array.isArray(sorter) ? sorter[0]?.order : sorter.order,
        },
      }),
      () => {
        scrollToAntSpinContainer();
        this.debouncedFetch();
      },
    );
  };

  handleShow = (key) => {
    if (!key) {
      showToast("error", this.props.t("Invalid data."));
      return;
    }
    if (key === "Not allowed") {
      return alert(
        `!You are not authorized to view or take any action on any other store.`,
      );
    }

    this.setState({ show: true, isData: key });
  };
  onUpdateAuto = async () => {
    this.setState({ isLoad: false }, () => this.debouncedFetch());
  };
  handleIsSearching = (_e) => {
    this.setState({ isSearching: _e });
  };

  handleSearch = (value) => {
    const startDate =
      value?.startDate && moment(value.startDate.$d).isValid()
        ? moment(value.startDate.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    const endDate =
      value?.endDate && moment(value.endDate.$d).isValid()
        ? moment(value.endDate.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

    this.setState(
      (prevState) => ({
        isLoad: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
            total: 0,
          },
          filters: {
            ...value,
            startDate,
            endDate,
            searchText: value?.searchText || "",
            typeSearch: value?.typeSearch || "",
            status: value?.status || "",
          },
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        this.debouncedFetch();
      },
    );
  };

  handleShowModelDetelCustomer = async (item) => {
    if (!item) {
      alert(this.props.t("Invalid data."));
      return;
    }
    let info = { customerUuid: item?.customerUuid };
    this.setState({ customerData: info }, () => {
      this.detailsCustomer(item);
    });
  }

  onSearchCustomerData = async (event) => {
    let res = await getSearchCustomerData(event);

    if (!res) return showToast("error", this.props.t("Customer data not found."));

    this.setState({ showDetailCustomer: true, isData: res });
  };

  detailsCustomer = async (item) => {
    if (!item) {
      alert(this.props.t("Invalid data."));
      return;
    }
    let { merchantId } = item || {};
    let { customerData } = this.state;

    const newTableParams = {
      search: customerData?.customerUuid,
      typeSearch: "customer_uuid",
      merchantId: merchantId,
    };
    await this.onSearchCustomerData(newTableParams);

  }

  render() {
    const { resAllDataMerchang, nameMerchang, activeKey1, allBankAccountData, resProfileAdmin } = this.context;
    const { handleShow, handleShowModelDetelCustomer } = this;
    const { activeTabKey1, show, isData, isLoad, tableParams, dataTable, showDetailCustomer, isSearching } =
      this.state;

    const setActiveTabKey1 = (key) => {
      this.setState({ activeTabKey1: key });
    };

    const onTab1Change = (key) => {
      setActiveTabKey1(key);
    };

    let count = Intl.NumberFormat().format(tableParams?.pagination?.total) || 0;
    let countData = Intl.NumberFormat().format(tableParams?.pagination?.total) || 0;
    let isDate = `${tableParams?.filters?.startDate || ""} - ${tableParams?.filters?.endDate || ""}`
    const tabList = [
      {
        key: "tab1",
        tab: `${!isSearching ? t("transaction_verifySlip_list_today", {
          count: count,
        }) : t("transaction_verifySlip_list_date", {
          date: isDate,
          count: countData,
        })}`,
      },
    ];
    const userPermissions = Array.isArray(resProfileAdmin?.permissions)
      ? resProfileAdmin.permissions
      : [];

    // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน

    const accessible_details_customer = hasPermission(userPermissions, "details_customer");

    const accessible_details = hasPermission(userPermissions, "details_verifyslip"); // details


    const accessible_verify = hasPermission(userPermissions, "verify_verifyslip"); // verify

    let columns = ColumnsVerifySlip(
      t,
      handleShow,
      handleShowModelDetelCustomer,
      accessible_details,
      accessible_details_customer
    );

    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id}
              onChange={this.handleTableChange}
              dataSource={dataTable}
              loading={isLoad}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`,
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
              rowClassName={getRowClassName}
            />
          </div>
        </>
      ),
    };

    return (
      <>
        <DetailModel
          handleClose={this.handleClose}
          resAllDataMerchang={resAllDataMerchang}
          isData={isData}
          show={show}
          t={t}
        />
        <DetailModelCustomer
          handleClose={this.handleClose}
          isData={isData}
          showToast={showToast}
          show={showDetailCustomer}
          activeTabKey1={activeTabKey1}
          allBankAccountData={allBankAccountData}
          resAllDataMerchang={resAllDataMerchang}
          nameMerchang={nameMerchang}
          t={t}
        />
        {/* **แก้ไข**: ใช้ this.state.isLoad สำหรับ Spin */}
        <Spin spinning={isLoad}>
          <div style={{ flex: 1 }}>
            <div>
              <div className="container-fluid">
                <PageHeader
                  HeaderText={t("CheckSlipWithOutQr")}
                  Breadcrumb={[
                    {
                      name: removeSlashesFromPath(window.location.pathname),
                      navigate: window.location.pathname,
                    },
                  ]}
                />
                {/* Search */}
                <SearchTransactions
                  t={t}
                  type={"verifyslip"}
                  onSearch={this.handleSearch}
                  handleIsSearching={this.handleIsSearching}
                  activeKey1={activeKey1}
                />
                <Card
                  title={
                    <>
                      <ContentVerifySlip
                        handleClose={this.handleClose}
                        nameMerchang={nameMerchang}
                        t={t}
                        fetchData={this.fetchData}
                        resAllDataMerchang={resAllDataMerchang}
                        accessible_verify={accessible_verify}
                      />
                    </>
                  }
                  style={{ boxShadow: "none" }}
                  extra={null}
                  tabList={tabList}
                  activeTabKey={activeTabKey1}
                  onTabChange={onTab1Change}
                >

                  {contentList[activeTabKey1]}
                  <FooterVerifyslip t={t} />
                </Card>
              </div>
            </div>
          </div>
        </Spin>
        <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />

      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

// **แก้ไข**: ตรวจสอบว่ามีการ import Tag หรือไม่, ถ้าไม่มีการใช้ใน ColumnsVerifySlip หรือที่อื่น
// จะต้อง import เข้ามาด้วย (ได้เพิ่ม Tag ในการ import ที่ด้านบนสุดแล้ว)
export default connect(mapStateToProps, {})(withTranslation()(Index));
